import { useMutation } from '@tanstack/react-query';
import Api from '../libs/api';

export const usePaymentExit = () => {
	const { mutateAsync: paymentExit } = useMutation({
		mutationFn: async (ptIdx: number) => await Api.patch('/payment/exit', { ptIdx }),
	});
	return { paymentExit };
};
